import React from 'react'
import { Box } from 'chemistry'
import { clsx } from 'clsx'

const DeliveryModeLabel = ({ deliveryMode, position = 'right' }) => {
  if (!deliveryMode) return null

  return (
    <Box
      className={clsx('mxd-promotion-label', {
        'mxd-promotion-label-bottom-left': position === 'left'
      })}
      display='inline-block'
      p='8px 16px'
      backgroundColor='black'
      color='var(--chakra-colors-white-0)'
      lineHeight='1.5714285714'
      fontFamily='RubrikNew-Bold,Ubuntu,sans-serif'
      letterSpacing='.1px'
      textTransform='uppercase'
    >
      {deliveryMode}
    </Box>
  )
}

export default DeliveryModeLabel
